import React from "react";

import LeaveMeetingButton from "./LeaveMeetingButton";
import DefaultMeetingEventLogo from "./DefaultMeetingEventLogo";

const WherebyMeetingEmbed = ({
  meetingLink,
  companyProfile,
  companyId,
  role,
  onClickLeaveMeeting = () => {},
}) => {
  return (
    <div
      className={`video-container w-100 my-3 ${
        companyProfile && companyProfile.BannerImage
          ? "has-step-repeat-banner"
          : ""
      }`}
      style={{
        position: "relative",
        backgroundImage: `${
          companyProfile && companyProfile.BannerImage
            ? `url(${companyProfile.BannerImage})`
            : "none"
        }`,
      }}
    >
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          src={meetingLink}
          className="w-100 h-100 border-0 embed-responsive-item"
          title={"Reception room"}
          allow="camera; microphone; fullscreen; speaker; display-capture"
        />

        <LeaveMeetingButton
          userRole={role}
          companyId={companyId}
          onClick={() => onClickLeaveMeeting(true)}
        />

        {companyProfile && !companyProfile.BannerImage ? (
          <DefaultMeetingEventLogo />
        ) : null}
      </div>
    </div>
  );
};

export default WherebyMeetingEmbed;
